import { Component } from 'react';
import { useParams } from 'react-router';
import { Button, Result } from 'antd';
import { VideoProjectProvider } from '@contexts/VideoProject.context';
import VideoProjectView from './VideoProjectView';

/**
 * The video project page, made again for each project: what was picked or waits for a confirmation in one project
 * can never be sent to another's analysis. An error while drawing it shows a way back instead of a blank app.
 */
class PageBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = { failed: false };
	}

	static getDerivedStateFromError() {
		return { failed: true };
	}

	componentDidCatch(error, info) {
		console.error('The video project page failed', error, info?.componentStack);
	}

	render() {
		if (!this.state.failed) return this.props.children;
		return (
			<Result
				status="warning"
				title="This page could not be shown"
				subTitle="Your video and its results are saved."
				extra={
					<Button type="primary" onClick={() => window.location.reload()}>
						Reload
					</Button>
				}
			/>
		);
	}
}

const VideoProjectRoute = () => {
	const { project_uuid } = useParams();
	return (
		<PageBoundary key={project_uuid}>
			<VideoProjectProvider>
				<VideoProjectView />
			</VideoProjectProvider>
		</PageBoundary>
	);
};

export default VideoProjectRoute;
